import ClipboardJS from "clipboard";

export function copyUrl() {
    let $links = $(".copy-link");
    let tooltip = "<span class='clipboard-success-img'>Copied to clipboard!</span>";
    let showSuccessTooltip = function (link) {
        $(link).siblings().show(200);

        setTimeout(() => {
            $(link).siblings().hide(200);
        }, 1000);
    };

    $links.each(function () {
        $(this).closest("li").append(tooltip);
    });

    $links.on("click", function (e) {
        e.preventDefault();
    });

    new ClipboardJS(".copy-link", {
        text: function (trigger) {
            showSuccessTooltip(trigger);
            return trigger.getAttribute("href");
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/copyUrl.js